import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetDataExportActivityData, IGetDataExportActivityVars } from '../types';

export const GET_DATA_EXPORT_ACTIVITY: TypedDocumentNode<IGetDataExportActivityData, IGetDataExportActivityVars> = gql`
  query getDataExportActivityQuery($input: DataExportActivityQueryInput!) {
    getDataExportActivity(input: $input) {
      lastName
      firstName
      username
      lastGeneratedOn
    }
  }
`;
